import axios from 'axios'

import env from '../environments'

export async function authenticate(id: string) {
	const response = await axios.post(`${env.chatbotApiUrl}/auth/${id}`)

	return response.data as {accessToken: string}
}

export async function authenticatePreview(id: string, accessToken: string) {
	const response = await axios.post(
		`${env.chatbotApiUrl}/auth/${id}/preview`,
		{},
		{
			headers: {
				// eslint-disable-next-line @typescript-eslint/naming-convention
				Authorization: `Bearer ${accessToken}`
			}
		}
	)

	return response.data as {accessToken: string}
}
